module.exports = "<div id=\"sourcelink-loading-region\"></div>\r\n<div id=\"sourcelink-content-region\">\r\n   \r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/settings/views/source-link-settings.html
// module id = 434
// module chunks = 1